import React, { FC, MouseEvent, ReactNode } from 'react';
import { Link as RouterDomLink } from 'react-router-dom';
import { Link as MMLink } from '@missionme/mime_elements';

type TProps = {
  to?: string;
  href?: string;
  className?: string;
  children: ReactNode;
  onClick?: (evt: MouseEvent<HTMLAnchorElement>) => void;
  dataCyName?: string;
  title?: string;
  color?: string;
  target?: string;
  rel?: string;
};

export const Link: FC<TProps> = ({ to, href, className, children, onClick, dataCyName, title, color, target, rel }) => {
  return (
    <MMLink
      // @ts-ignore
      component={to && RouterDomLink}
      to={to}
      href={href}
      className={className}
      onClick={onClick}
      dataCyName={dataCyName}
      title={title}
      color={color}
      target={target}
      rel={rel}
    >
      {children}
    </MMLink>
  );
};
